import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, join } from 'lodash';
import Modal from 'react-modal';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import ModalB from 'components/Modal/ModalB';
import ImageGallery from 'components/ImageGallery/ImageGalleryA';
import InstructorB from 'components/Instructor/InstructorB';
import SeminarLocation from 'components/SeminarDetails/SeminarLocation';
import SeminarDateTime from 'components/SeminarDetails/SeminarDateTime';
import { priceFormatter } from 'utils/Numbers';
import BuildChildren from 'utils/BuildChildren';
import { buildProductStructuredData } from 'utils/StructuredData';
import classes from './CardProductJ.module.scss';

class CardProductJ extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      selectedInstructor: null,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal = (e, instructorObj) => {
    e.preventDefault();
    e.stopPropagation();
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
      selectedInstructor: instructorObj,
    });
  };

  render() {
    const {
      displayName,
      description,
      imageURI,
      imageAltText,
      price,
      originalPrice,
      isAffirmEligible,
      button,
      seminarInfo,
      skillLevel,
      creditHours = [],
      subjects = [],
      courseType,
      courseFormat,
      secondaryImages = [],
      productSpecifications = [],
      authors = [],
    } = this.props;

    const {
      instructorsDetails = [],
      sessions = [],
      timeZone,
      venue,
      street,
      city,
      state,
      postalCode,
    } = seminarInfo || {};

    const { isOpen, selectedInstructor } = this.state;

    const creditHoursDisplay = creditHours.length > 0 &&
      join(creditHours.map((i) => `${i.type} ${i.hours.toFixed(2)}`), '\n');

    const images = [{ imageURI, imageAltText }, ...secondaryImages];

    const showLocation = venue || street || city || state || postalCode;
    const showCourseInfoLeft = creditHours.length > 0 || courseFormat || courseType;
    const showCourseInfoRight = (skillLevel && skillLevel !== 'None') || showLocation || subjects.length > 0;
    const showProdSpecs = productSpecifications.length > 0;
    const showAuthors = authors.length > 0;
    const showCourseInfoBottom = sessions.length > 0;
    const showRight = imageURI || price || originalPrice || isAffirmEligible
      || button || showCourseInfoLeft || showCourseInfoRight || showCourseInfoBottom;
    const showLeft = description || instructorsDetails.length > 0;
    const showTop = displayName;

    const renderCourseInfo = (heading, body) => (
      heading && body &&
      <div className={classes.courseDetail}>
        <div className={classes.courseHeading}>{heading}</div>
        <div className={classes.courseBody}>{body}</div>
      </div>
    );

    const renderCourseDates = (tz) => (
      sessions.map(({ start, end }, idx) => (
        <div key={`course-date-${idx}`}>
          <SeminarDateTime startDate={start} endDate={end} timeZone={tz} asSpan />
          {sessions.length - 1 !== idx ? '\n' : ''}
        </div>
      ))
    );

    const renderAuthors = () => (
      authors.length > 0 &&
      <div className={classes.authorContentBox}> {
        authors.map((author, authorIdx) => {
          const { name, images: authorImages, biography, heading } = author;

          const authorForModal = {
            content: biography,
            name,
            title: 'Author BIO',
            heading,
            image: {
              url: authorImages?.[0]?.imageURI,
              altText: authorImages?.[0]?.imageAltText,
            },
          };

          return (
            <button
              key={authorIdx}
              className={classes.authorButton}
              type='button'
              onClick={(e) => this.toggleModal(e, authorForModal)}
            >
              <div className={classes.instructorViewDetails}>{name}</div>
            </button>
          );
        })
      }
      </div>
    );

    const renderCourseLocation = () => (
      showLocation &&
      <SeminarLocation
        venue={venue}
        street={street}
        city={city}
        state={state}
        postalCode={postalCode}
      />
    );

    const renderInstructors = () => (
      (instructorsDetails && instructorsDetails.map((i, idx) => {
        const { name, title, image } = i;
        const { url, altText } = image || {};
        const instructorImage = (
          url && <img
            className={classes.instructorImage}
            src={url}
            alt={altText}
            width={70}
            height={70}
            loading='lazy'
            aria-hidden
          />
        );
        const exists = !isEmpty(title);
        const viewDetails = (exists && (
          <button
            className={classes.instructorButton}
            type='button'
            onClick={(e) => this.toggleModal(e, { ...i, title: 'Instructor BIO' })}
          >
            <div className={classes.instructorViewDetails}>View Bio</div>
          </button>
        )) || null;
        return (
          <div className={classes.instructorWrapper} key={`${name}-${idx}`}>
            {instructorImage &&
              <div className={classes.instructorImage}>
                {instructorImage}
              </div>}
            <div className={classes.instructorDetails}>
              {name && <div className={classes.instructorName} dangerouslySetInnerHTML={{ __html: name }} />}
              {viewDetails}
            </div>
          </div>
        );
      }))
    );

    return (
      <div className={classes.container}>
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: buildProductStructuredData(this.props) }}
        />
        <Modal
          isOpen={isOpen}
          onRequestClose={(e) => this.toggleModal(e, null)}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          className={classes.modal}
          overlayClassName={classes.overlayModal}
          closeTimeoutMS={250}
        >
          <ModalB hideModal={(e) => this.toggleModal(e, null)}>
            <InstructorB {...selectedInstructor} />
          </ModalB>
        </Modal>
        <div className={classes.containerWrapper}>
          {showTop &&
            <div className={classes.top}>
              {displayName &&
                <h1
                  className={classes.displayName}
                  dangerouslySetInnerHTML={{ __html: displayName }}
                />}
            </div>}
          {showLeft &&
            <div className={classes.left}>
              {description &&
                <div
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: description }}
                />}
              {instructorsDetails.length > 0 &&
                <div className={classes.instructors}>
                  {renderInstructors()}
                </div>}
            </div>}
          {showRight &&
            <div className={classes.right}>
              {imageURI && <ImageGallery items={images} sliderHeight='162px' showAltText={false} />}
              {(price || originalPrice) &&
                <div className={classes.priceWrapper}>
                  {originalPrice > price &&
                    <span className={classes.originalPrice}>{priceFormatter(originalPrice)}</span>}
                  {price >= 0 && <span className={classes.price}>{priceFormatter(price)}</span>}
                </div>}
              {isAffirmEligible &&
                <div className={classes.affirmMessage}>
                  <AffirmContainer
                    price={price}
                    isAffirmEligible={isAffirmEligible}
                    className={classes.affirmMessage}
                  />
                </div>}
              {button && <div className={classes.cartButton}>{BuildChildren(button)}</div>}
              {(showCourseInfoLeft || showCourseInfoRight || showProdSpecs || showAuthors) &&
                <>
                  <hr className={classes.hr} />
                  <div className={classes.coursesWrapper}>
                    {renderCourseInfo(authors.length > 1 ? 'AUTHORS' : 'AUTHOR', renderAuthors())}
                    {renderCourseInfo('CREDITS', creditHoursDisplay)}
                    {renderCourseInfo('COURSE LEVEL', skillLevel !== 'None' && skillLevel)}
                    {renderCourseInfo('COURSE TYPE', courseType)}
                    {renderCourseInfo('SUBJECT / FIELD OF STUDY', join(subjects.map((i) => i), '\n'))}
                    {renderCourseInfo('FORMAT', courseFormat)}
                    {renderCourseInfo('LOCATION', renderCourseLocation())}
                    {
                      showProdSpecs &&
                      productSpecifications.map((ps) => renderCourseInfo(ps.key.toUpperCase(), ps.value))
                    }
                  </div>
                </>}
              {showCourseInfoBottom &&
                <div className={classes.courseBottom}>
                  {sessions.length > 0 && renderCourseInfo('DATE', renderCourseDates(timeZone))}
                </div>}
            </div>}
        </div>
      </div>
    );
  }
}

CardProductJ.propTypes = {
  /**
   * Product author's
  */
  authors: PropTypes.arrayOf(PropTypes.shape({
    biography: PropTypes.string,
    heading: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      altText: PropTypes.string,
    })),
    name: PropTypes.string,
  })),

  /**
   * Product title that displays at the top of the card
  */
  displayName: PropTypes.string,
  /**
  * Product price
  */
  price: PropTypes.number,
  /**
  * Product original price
  */
  originalPrice: PropTypes.number,
  /**
  * Product credit hours
  */
  creditHours: PropTypes.array,
  /**
  * Add to cart button of the product
  */
  button: PropTypes.object,
  /**
  * Product description
  */
  description: PropTypes.string,
  /**
  * Product skill level
  */
  skillLevel: PropTypes.string,
  /**
  * Product approval text
  */
  approvalText: PropTypes.string,
  /**
  * If the product is a seminar this is the object that hold the details
  */
  seminarInfo: PropTypes.shape({
    timeZone: PropTypes.string,
    venue: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    sessions: PropTypes.arrayOf(PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string,
    })),
    instructorsDetails: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      heading: PropTypes.string,
      subheading: PropTypes.string,
      instructorId: PropTypes.number,
      content: PropTypes.string,
      additionalContent: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        altText: PropTypes.string,
      }),
    })),
  }),
  /**
  * Can you use affirm on this product
  */
  isAffirmEligible: PropTypes.bool,
  /**
   * Product subjects
  */
  subjects: PropTypes.arrayOf(PropTypes.string),
  /**
  * URL to product detail page
  */
  productDetailUrl: PropTypes.string,
  /**
  * Course Type
  */
  courseType: PropTypes.string,
  /**
  * Course Format
  */
  courseFormat: PropTypes.string,
  /**
   * Image URL
  */
  imageURI: PropTypes.string,
  /**
  * Image alternate text that displays on hover over of image
  */
  imageAltText: PropTypes.string,
  /**
  * Secondary Images to image gallery
  */
  secondaryImages: PropTypes.arrayOf(PropTypes.shape({
    ImageUri: PropTypes.string,
    ImageAltText: PropTypes.string,
  })),
  /**
   * Product Specifications
   * key/value pair of additional product properties
  */
  productSpecifications: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default CardProductJ;
